// extracted by mini-css-extract-plugin
export default {"pagination":"fTdWZ6","page":"eYCCcM","active":"ZImUzz","pageLink":"hw89uO","arrowLink":"zLbSmq"};